import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup, ValidatorFn,
  Validators,
} from '@angular/forms';

import { FloorPlan } from '@shared/floor-plan/models';
import { NAME_PATTERN, ValidationService } from '@tablesready/common-ui';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon } from '@tablesready/frontend-icons';

export enum FloorPlanModalMode {
  add = 'Add',
  edit = 'Edit',
  delete = 'Delete',
}

@Component({
  selector: 'tablesready-floorplan-modal',
  templateUrl: './floorplan-modal.component.html',
  styleUrls: ['./floorplan-modal.component.scss'],
})
export class FloorplanModalComponent implements OnInit {
  @Input() mode = FloorPlanModalMode.add;
  @Input() item?: FloorPlan;
  @Input() defaultChecked = false;
  @Input() floorplans?: FloorPlan[];
  @Input() onClose?: (
    mode: FloorPlanModalMode,
    item: FloorPlan,
    instance: FloorplanModalComponent,
    deleteResources?: boolean,
  ) => void;

  form?: FormGroup;
  modalMode = FloorPlanModalMode;
  deleteResources = new FormControl(false, Validators.required);

  icon = AppIcon;

  constructor(
    private readonly validationService: ValidationService,
    private readonly formBuilder: FormBuilder,
    private readonly modalController: FrontendModalService,
  ) {}

  get nameControl(): AbstractControl {
    return this.form.get('name');
  }

  ngOnInit(): void {
    let item: FloorPlan = {
      id: '',
      locationId: '',
      name: '',
      default: this.defaultChecked,
    };

    if (this.mode === FloorPlanModalMode.edit && this.item !== undefined) {
      item = this.item;
    }

    this.form = this.formBuilder.group({
      id: item.id,
      name: [item.name, [Validators.required, Validators.pattern(NAME_PATTERN), this.checkFloorPlanNameIsUnique()]],
      default: item.default,
    });

    if (this.defaultChecked) {
      const control = this.form.get('default');
      control.setValue(true);
      control.disable();
    }
  }

  close(): void {
    this.modalController.dismiss();
  }

  submit(): void {
    this.validationService.validateForm(this.form);
    if (!this.form.valid) {
      return;
    }

    if (this.onClose !== undefined) {
      this.onClose(this.mode, this.form.getRawValue(), this, this.deleteResources.value);
    }
  }

  private checkFloorPlanNameIsUnique(): ValidatorFn {
    return (control: AbstractControl) => {
      const name = control.value;
      const nameIsNotUnique = this.floorplans
        .findIndex(floorplan => floorplan.name.toLowerCase() === name.toLowerCase() && floorplan.id !== this.item?.id) !== -1;

      return nameIsNotUnique ? { recordAvailability: true } : null;
    };
  }
}
